// extracted by mini-css-extract-plugin
export default {"quantity":"AccessoryItem_quantity__dSElZ"};